import openDatabase from "../../IndexedDB/openDatabase";

const storePackageAccessResInIndexedDB = async (
  packageAccessRes,
  dbName = "ERP_DB",
  storeName = "Client_Details",
  dbVersion = 1
) => {
  try {
    // Open or create the database and object store
    const db = await openDatabase(dbName, storeName, dbVersion);

    // Start a readwrite transaction
    const transaction = db.transaction(storeName, "readwrite");
    const store = transaction.objectStore(storeName);

    // Iterate over each key-value pair in clientData and store them in one transaction
    for (const [key, value] of Object.entries(packageAccessRes)) {
      store.put(value, key); // Store each key-value pair in the object store
    }

    // Wait for the transaction to complete
    await transaction.complete;
    console.log("Client data stored successfully");
  } catch (error) {
    console.error("Error storing client data:", error);
  }
};

export default storePackageAccessResInIndexedDB;
